
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/d0f62ea7053e0d25f57e25377554c73f.jpg"
          alt="TMI Chrome Processing Plant Rustenburg"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-5xl mx-auto pt-24">
        <div className="inline-block bg-white/15 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-semibold mb-8 font-['Lato'] tracking-wide">
          CHROME COMMODITY TRADING &amp; PROCESSING
        </div>
        <h1 className="font-['Montserrat'] font-bold text-white mb-6">
          <div className="text-5xl md:text-6xl lg:text-7xl leading-tight">CREATING VALUE</div>
          <div className="text-5xl md:text-6xl lg:text-7xl leading-tight mt-2">FROM <span className="text-[#D4A574]">CHROME</span></div>
        </h1>
        <p className="text-lg md:text-xl text-white/85 mb-12 max-w-3xl mx-auto font-['Lato'] leading-relaxed">
          South Africa&apos;s trusted chrome ore beneficiation partner. We transform raw materials into premium concentrate from our Rustenburg processing plant — delivering quality chrome products directly from source.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link
            to="/mining"
            className="bg-[#8B1538] text-white px-12 py-5 rounded-lg text-lg font-semibold hover:bg-[#6B0F2A] transition-all duration-300 inline-flex items-center gap-3 shadow-2xl hover:shadow-[#8B1538]/40 whitespace-nowrap cursor-pointer"
          >
            Our Chrome Operations
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
          <Link
            to="/contact"
            className="border-2 border-white/60 text-white px-12 py-5 rounded-lg text-lg font-semibold hover:bg-white/10 transition-all duration-300 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            Request a Quote
          </Link>
        </div>

        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white font-['Montserrat']">8+</div>
            <div className="text-sm text-white/70 mt-1 font-['Lato']">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white font-['Montserrat']">1000</div>
            <div className="text-sm text-white/70 mt-1 font-['Lato']">MT Weekly Output</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white font-['Montserrat']">40+</div>
            <div className="text-sm text-white/70 mt-1 font-['Lato']">Years Team Expertise</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white font-['Montserrat']">100%</div>
            <div className="text-sm text-white/70 mt-1 font-['Lato']">Client Focused</div>
          </div>
        </div>
      </div>
    </section>
  );
}
